import React from 'react';

interface EncountersPrimaryHeaderProps {
  title: string;
}

/**
 * Primary header component for encounters table
 * Displays the table title with affiliated location information
 */
const EncountersPrimaryHeader: React.FC<EncountersPrimaryHeaderProps> = ({
  title,
}): React.ReactElement => {
  return (
    <div className="flex h-auto items-center gap-4 self-stretch px-4 py-6 border-b border-neutral-300">
      <div className="flex flex-col items-start flex-1">
        <div className="flex items-center gap-2">
          <h1 className="self-stretch justify-start text-primary text-xl font-bold font-['Inter'] leading-7">
            Affiliated Providers -{' '}
            <span className="text-xl font-semibold leading-relaxed font-inter text-teal-600">
              {title}
            </span>
          </h1>
        </div>
        <p className="text-secondary text-sm font-normal font-['Inter'] leading-tight">
          All providers practicing or with admitting rights at this location
        </p>
      </div>
    </div>
  );
};

export default EncountersPrimaryHeader;
